module.exports = __webpack_public_path__ + "img/icon_shopingbag.d9658208.svg";